<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :payroll="payroll" />
    </div>
    <div class="content">
      <div class="quickpay">
        <div>
          <p>Run Payroll Fast</p>
          <div class="quickpay_div">
            <div class="quickpay__image">
              <img src="./../../../assets/images/csv.png" alt />
            </div>
            <span>Upload Payroll Excel Sheet</span>
            <p>
              <span class="quickpay__paragraph--bold">Steps:</span>
              <br />
              <br />1. Download the
              <a :href="downloadUrl" download>Payroll Template</a> and fill in
              your employee details, fill in the detail and download as
              Microsoft Excel. <br />
              <span class="ita"
                >See the list of
                <router-link to="/bank-codes" target="_blank"
                  >bank codes here.</router-link
                >
                <span> </span
              ></span>
              <br />
              <br />2. Upload the updated template back and you are ready to
              pay.
            </p>
            <div class="quickpay__upload">
              <div v-show="!uploadedFile">
                <img src="./../../../assets/images/uploadcsv.png" alt />
              </div>
              <span v-show="!uploadedFile">Select File</span>
              <p v-show="!uploadedFile">or drop your file here</p>
              <p v-show="uploadedFile">{{ uploadedFileName }}</p>
              <input type="file" ref="csv" @change="uploadCsv" />
            </div>
            <div class="quickpay__err">
              <span v-if="noEmployee"
                >You have uploaded an empty file. Please fill data and try
                again.</span
              >
              <span v-if="noFile"
                >Please uplaod a csv file with extensions " .csv, .xls,
                .xlsx".</span
              >
              <span v-if="fileSize">File must be less than 200kb.</span>
              <span v-if="networkErr"
                >Network error. Please try again later.</span
              >
            </div>
            <div class="quickpay__btns">
              <div
                class="quickpay__btns--upload"
                v-if="!btnLoader"
                @click="sendCsv"
              >
                Upload Template
              </div>
              <div class="quickpay__btns--upload" v-if="btnLoader">
                <WhiteLoader />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="quickpay__modal" v-if="modal">
        <div>
          <div>
            <div>
              <img src="./../../../assets/images/warning.png" alt="Alert" />
            </div>
            <p>{{ respMsg }}</p>
            <div class="quickpay__modal__btn">
              <div class="quickpay__modal__btn-proceed" @click="proceedPayroll">
                Proceed
              </div>
              <div class="quickpay__modal__btn-cancel" @click="closeModal">
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "OnetimeUpload",
  components: {
    Header,
    Sidebar,
    WhiteLoader,
  },
  data() {
    return {
      item: "quick",
      downloadUrl: "",
      payroll: "payroll",
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      fileExt: "",
      noFile: false,
      fileSize: false,
      btnLoader: false,
      respMsg: "",
      networkErr: false,
      modal: false,
      noEmployee: false,
    };
  },
  methods: {
    proceedPayroll() {
      this.$router.push("/onetime-preview");
    },
    closeModal() {
      this.modal = false;
      this.uploadedFile = false;
      this.$refs.csv.value = "";
      this.file = "";
    },
    uploadCsv() {
      this.uploadedFile = false;
      this.noFile = false;
      this.fileSize = false;
      this.networkErr = false;
      this.noEmployee = false;
      this.fileName = this.$refs.csv;
      this.file = this.$refs.csv.files[0];
      this.fileExt = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
      }
    },
    sendCsv() {
      if (!this.fileExt) {
        this.noFile = true;
        return;
      }

      if (!this.file) {
        this.noFile = true;
        return;
      }

      if (
        this.fileExt.toLowerCase().trim() === "csv" ||
        this.fileExt.toLowerCase().trim() === "xls" ||
        this.fileExt.toLowerCase().trim() === "xlsx"
      ) {
        if (this.file.size > 200000) {
          this.fileSize = true;
          return;
        }

        const user = this.$store.getters.currentAuthUser;
        const user_id = user.id;

        const date = new Date();
        this.months = [
          "January",
          "Febuary",
          "March",
          "April",
          "May",
          "june",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const dateValue = date.getMonth();
        const month = this.months[dateValue];
        const year = date.getFullYear();
        const type = "one-off";

        this.btnLoader = true;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("month", month);
        formData.append("year", year);
        formData.append("type", type);
        formData.append("user_id", user_id);

        this.$http
          .post(types.PAYROLL_BREAKDOWN_POST_API, formData)
          .then((resp) => {
            this.$store.state.onetime = resp.data.data.record;

            if (resp.data.data.success !== 0) {
              this.respMsg = `${resp.data.message} The following error(s) occured. `;
              if (resp.data.data.errors.length > 0) {
                for (let index of resp.data.data.errors) {
                  this.respMsg =
                    this.respMsg +
                    " For Employee with account number " +
                    index.employee.account_number +
                    ", ";
                  let demo = "";
                  for (let num in index.error) {
                    demo = demo + index.error[num];
                  }
                  this.respMsg = this.respMsg + demo + ".";
                }

                if (this.respMsg) {
                  this.modal = true;
                }
              } else {
                this.$router.push("/onetime-preview");
              }
            } else {
              this.uploadedFile = false;
              this.$refs.csv.value = "";
              this.file = "";
              this.noEmployee = true;
            }

            this.btnLoader = false;
          })
          .catch(() => {
            this.btnLoader = false;
            this.networkErr = true;
          });
        return;
      }
      this.noFile = true;
      return;
    },
  },
  mounted() {
    this.downloadUrl = types.STATIC_PAYROLL_TEMPLATE;
  },
};
</script>

<style lang="scss" scoped>
.quickpay {
  //   background-color: #fbfafa;
  padding-top: 5rem;
  padding-bottom: 7rem;
  padding-left: 2rem;
  padding-right: 2rem;
  //   min-height: 700px

  @media (max-width: 768px) {
    padding: 0;
  }

  .quickpay_div {
    padding: 1rem;
  }

  > div {
    @media (max-width: 768px) {
      margin-top: 3rem;
      padding: 1rem;
    }

    > p {
      font-size: 25px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      border-bottom: 1px solid #caced5;
    }

    > div {
      max-width: 50rem;
      margin: 2rem auto;
      text-align: center;
      padding: 1.2rem 5rem;

      > .quickpay__image {
        width: 5rem;
        width: 5rem;
        margin: 0 auto 30px auto;
      }

      > span {
        font-size: 1.2rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      .ita {
        color: #000;
        font-weight: 200;
      }

      > p {
        font-size: 1rem;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin: 3rem 0;

        > .quickpay__paragraph--bold {
          font-weight: 500;
        }

        .quickpay__paragraph--orange {
          color: #f79320;
        }

        > a {
          color: #5099de;
          text-decoration: none;
        }
      }

      > .quickpay__upload {
        width: 20rem;
        padding: 2rem;
        border: dashed 1px #5099de;
        margin: 10px auto;
        position: relative;

        > input {
          position: absolute;
          top: 0;
          left: 0;
          background-color: red;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
        }

        > div {
          width: 3rem;
          margin: 20px auto;

          > img {
            width: 100%;
          }
        }

        > span {
          font-size: 14px;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #5099de;
        }

        > p {
          font-size: 14px;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
        }
      }

      > .quickpay__err {
        font-size: 12px;
        color: red;
        font-style: italic;
        text-align: center;
        height: 30px;
      }

      > .quickpay__btns {
        width: 20rem;
        margin: 1rem auto 4rem auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .quickpay__btns--upload {
          width: 12rem;
          height: 40px;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
          margin: auto;
        }

        > .quickpay__btns--cancel {
          width: 45%;
          color: #000000;
          cursor: pointer;

          > a {
            color: #000000;
            text-decoration: none;

            > div {
              width: 100%;
              height: 40px;
              border-radius: 5px;
              background-color: #dcdcdc;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              font-size: 12px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: center;
            }
          }
        }
      }
    }
  }
}

.quickpay__modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999999;
  overflow: auto;
  z-index: 9999999;

  > div {
    max-width: 40rem;
    padding: 0 10px;
    margin: 50px auto;

    > div {
      background-color: #fff;
      padding: 20px;
      text-align: center;

      > div {
        width: 3rem;
        height: 40px;
        margin: 0 auto;
      }

      > p {
        font-size: 12px;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: red;
        margin: 20px 0;
      }

      > .quickpay__modal__btn {
        width: 30rem;
        margin: 20px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .quickpay__modal__btn-proceed {
          width: 45%;
          padding: 12px 0;
          text-align: center;
          background-color: #5099de;
          color: #fff;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
        }

        > .quickpay__modal__btn-cancel {
          width: 45%;
          padding: 12px 0;
          text-align: center;
          background-color: #dcdcdc;
          color: #000;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }
  }
}

.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    overflow: auto;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;
    margin-left: 200px;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }
  }
}
</style>